import { render, staticRenderFns } from "./my-uploadVideo.vue?vue&type=template&id=7c3d4515&scoped=true"
import script from "./my-uploadVideo.vue?vue&type=script&lang=js"
export * from "./my-uploadVideo.vue?vue&type=script&lang=js"
import style0 from "./my-uploadVideo.vue?vue&type=style&index=0&id=7c3d4515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3d4515",
  null
  
)

export default component.exports